(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6120],{

/***/ 42700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ DynamicLayout; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dynamic.js
var dynamic = __webpack_require__(41858);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/layout/dynamic-layout.tsx



const layouts = {
  standard: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9540), __webpack_require__.e(9068), __webpack_require__.e(4441), __webpack_require__.e(9426), __webpack_require__.e(9380)]).then(__webpack_require__.bind(__webpack_require__, 19380)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(19380)]
    }
  }),
  p100CheckoutPage: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9540), __webpack_require__.e(9068), __webpack_require__.e(4441), __webpack_require__.e(9426), __webpack_require__.e(287), __webpack_require__.e(4824)]).then(__webpack_require__.bind(__webpack_require__, 35738)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(35738)]
    }
  })
};

function getLayout(pageType) {
  switch (pageType) {
    case 'p100CheckoutPage':
      return layouts.p100CheckoutPage;

    case 'P060StandardPage':
    default:
      return layouts.standard;
  }
}

function DynamicLayout(_ref) {
  let {
    children
  } = _ref;
  const {
    data: page
  } = (0,cms/* usePage */.qt)();
  const Layout = getLayout(page === null || page === void 0 ? void 0 : page.type);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout, {
    children: [children, " "]
  });
}
;// CONCATENATED MODULE: ./src/layout/index.ts


/***/ }),

/***/ 70741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ DynamicPage; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dynamic.js
var dynamic = __webpack_require__(41858);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/page-type/dynamic-page.tsx



const pageTypes = {
  'module': dynamic_default()(() => __webpack_require__.e(/* import() */ 9345).then(__webpack_require__.bind(__webpack_require__, 89345)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(89345)]
    }
  }),
  'p180login': dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9540), __webpack_require__.e(9068), __webpack_require__.e(4441), __webpack_require__.e(9516), __webpack_require__.e(9426), __webpack_require__.e(7398)]).then(__webpack_require__.bind(__webpack_require__, 27398)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(27398)]
    }
  }),
  'p181profile': dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9540), __webpack_require__.e(9068), __webpack_require__.e(4441), __webpack_require__.e(9426)]).then(__webpack_require__.bind(__webpack_require__, 67975)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(67975)]
    }
  }),
  'p182resetPassword': dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9068), __webpack_require__.e(9516), __webpack_require__.e(7307)]).then(__webpack_require__.bind(__webpack_require__, 67307)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(67307)]
    }
  }),
  'p200favorites': dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(9540), __webpack_require__.e(9068), __webpack_require__.e(4441), __webpack_require__.e(9426), __webpack_require__.e(4191)]).then(__webpack_require__.bind(__webpack_require__, 94191)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(94191)]
    }
  })
};
function DynamicPage() {
  const {
    data: page
  } = (0,cms/* usePage */.qt)();
  const PageType = (page === null || page === void 0 ? void 0 : page.type) && pageTypes[page.type] || pageTypes.module;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageType, {});
}
;// CONCATENATED MODULE: ./src/page-type/index.ts


/***/ }),

/***/ 61893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SlugPage; }
/* harmony export */ });
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42700);
/* harmony import */ var _page_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70741);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55060);



var __N_SSG = true;
function SlugPage() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_page_type__WEBPACK_IMPORTED_MODULE_1__/* .DynamicPage */ .Q, {});
}

SlugPage.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_layout__WEBPACK_IMPORTED_MODULE_0__/* .DynamicLayout */ .O, {
    children: page
  });
};

/***/ }),

/***/ 63257:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(65271)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(52009)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(52983));

var _loadable = _interop_require_default(__webpack_require__(88854));

function dynamic(dynamicOptions, options) {
  let loadableFn = _loadable.default;
  let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: _ref => {
      let {
        error,
        isLoading,
        pastDelay
      } = _ref;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = () => dynamicOptions; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
const isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  const Loading = loadableOptions.loading; // This will only be rendered on the server side

  return () => /*#__PURE__*/_react.default.createElement(Loading, {
    error: null,
    isLoading: true,
    pastDelay: false,
    timedOut: false
  });
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 81666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(52009)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(52983));

const LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 88854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(65271)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(52009)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(52983));

var _loadableContext = __webpack_require__(81666);

const {
  useSyncExternalStore
} =  true ? __webpack_require__(52983) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;

function load(loader) {
  let promise = loader();
  let state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(loaded => {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(err => {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  let opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  let subscription = null;

  function init() {
    if (!subscription) {
      const sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    const moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(ids => {
        for (const moduleId of moduleIds) {
          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    const context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(moduleName => {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, () => ({
      retry: subscription.retry
    }), []);

    return _react.default.useMemo(() => {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref
    }));
  }

  const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = () => init();

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

class LoadableSubscription {
  promise() {
    return this._res.promise;
  }

  retry() {
    this._clearTimeouts();

    this._res = this._loadFn(this._opts.loader);
    this._state = {
      pastDelay: false,
      timedOut: false
    };
    const {
      _res: res,
      _opts: opts
    } = this;

    if (res.loading) {
      if (typeof opts.delay === 'number') {
        if (opts.delay === 0) {
          this._state.pastDelay = true;
        } else {
          this._delay = setTimeout(() => {
            this._update({
              pastDelay: true
            });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === 'number') {
        this._timeout = setTimeout(() => {
          this._update({
            timedOut: true
          });
        }, opts.timeout);
      }
    }

    this._res.promise.then(() => {
      this._update({});

      this._clearTimeouts();
    }).catch(_err => {
      this._update({});

      this._clearTimeouts();
    });

    this._update({});
  }

  _update(partial) {
    this._state = _extends({}, this._state, {
      error: this._res.error,
      loaded: this._res.loaded,
      loading: this._res.loading
    }, partial);

    this._callbacks.forEach(callback => callback());
  }

  _clearTimeouts() {
    clearTimeout(this._delay);
    clearTimeout(this._timeout);
  }

  getCurrentValue() {
    return this._state;
  }

  subscribe(callback) {
    this._callbacks.add(callback);

    return () => {
      this._callbacks.delete(callback);
    };
  }

  constructor(loadFn, opts) {
    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  let promises = [];

  while (initializers.length) {
    let init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(() => {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = () => {
  return new Promise((resolveInitializers, reject) => {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  let ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(resolvePreload => {
    const res = () => {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 49897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(61893);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63257)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49897); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);